export const getSortValue = (type: string) => {
    return (
        {
            'address-asc': {
                sortOrder: 'address',
                sortDirection: 'asc'
            },
            'address-desc': {
                sortOrder: 'address',
                sortDirection: 'desc'
            },
            'sold-asc': {
                sortOrder: 'last_sale_date',
                sortDirection: 'asc'
            },
            'sold-desc': {
                sortOrder: 'last_sale_date',
                sortDirection: 'desc'
            },
            'price-paid-asc': {
                sortOrder: 'last_sale_price',
                sortDirection: 'asc'
            },
            'price-paid-desc': {
                sortOrder: 'last_sale_price',
                sortDirection: 'desc'
            }
        }[type] || {
            sortOrder: 'address',
            sortDirection: 'asc'
        }
    );
};
